import { deleteHomeCompany } from "actions/Utilities/HomeCompany";
import { toast } from "components/toastNotification";
import React from "react";
import { useMutation } from "react-query";
import { useRecoilState } from "recoil";
import { homeCompanyReFetching } from "../atoms/atoms";

export default function useDeleteHomeCompany() {
  const [isReFetching, setIsReFetching] = useRecoilState(
    homeCompanyReFetching
  );
  const { mutate } = useMutation(
    (ids: number[]) => deleteHomeCompany(ids),
    {
      onSuccess: (res: any) => {
        if (typeof res.data == "object") {
          toast.fire(
            "Disabling Home Company failed",
            res.Message,
            "error"
          );
        } else {
          switch (true) {
            case res.data == "Success":
              toast.fire(
                "Success",
                "Home Company Disabled Successfully",
                "success"
              );
              break;
            case res.data == "Notification insert Failed":
              toast.fire(
                "Success ",
                `Home Company Disabled Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res.data == "Operation Failed!":
              toast.fire(
                "Disabling Home Company failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res.data == "Home Company not found":
              toast.fire(
                "Disabling Home Company failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Disabling Home Company failed", res, "error");
          }
        }
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error) => {
        toast.fire(
          "Disabling Home Company failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );

  return mutate;
}
